__turbopack_context__.v({
  "arrow": "arrow-motion-module__gy5Nfa__arrow",
  "arrow-hover": "arrow-motion-module__gy5Nfa__arrow-hover",
  "arrow-hover-left": "arrow-motion-module__gy5Nfa__arrow-hover-left",
  "arrowLeft": "arrow-motion-module__gy5Nfa__arrowLeft",
  "trigger": "arrow-motion-module__gy5Nfa__trigger",
});
